import { render } from "./CustomerScreen.vue?vue&type=template&id=72cdd803&scoped=true"
import script from "./CustomerScreen.vue?vue&type=script&lang=js"
export * from "./CustomerScreen.vue?vue&type=script&lang=js"

import "./CustomerScreen.vue?vue&type=style&index=0&id=72cdd803&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cdd803"]])

export default __exports__